import {
  DirectorAnnotationWorkspace,
  DirectorMappingState,
  DirectorMark,
  DirectorRunView,
} from '../types';
import { request } from './index';

export interface SaveDirectorAnnotationsRequest {
  expectedVersion: number;
  baseContentHash: string;
  marks: DirectorMark[];
}

export type StartDirectorMappingResponse = DirectorRunView & { reused: boolean };

function episodePath(episodeId: string, suffix: string): string {
  return `/episodes/${encodeURIComponent(episodeId)}${suffix}`;
}

export const getDirectorAnnotations = (
  episodeId: string,
): Promise<DirectorAnnotationWorkspace> =>
  request(episodePath(episodeId, '/director-annotations'));

export const saveDirectorAnnotations = (
  episodeId: string,
  payload: SaveDirectorAnnotationsRequest,
): Promise<DirectorAnnotationWorkspace> =>
  request(episodePath(episodeId, '/director-annotations'), {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

export const startDirectorMapping = (
  episodeId: string,
): Promise<StartDirectorMappingResponse> =>
  request(episodePath(episodeId, '/director-mapping-runs'), { method: 'POST' });

export const getCurrentDirectorMapping = (
  episodeId: string,
): Promise<DirectorMappingState> =>
  request(episodePath(episodeId, '/director-mapping-runs/current'));
